import {
  INIT_HIGHSTATE,
  INIT_HIGHSTATE_RETURN,
  CHECKING_HIGHSTATE,
  HIGHSTATE_UPDATE,
  HIGHSTATE_REQUEST_FAILED,
} from "../actions/highstate";

const highstateInitialState = {
  message: null,
  status: null,
  fetching: false,
  failures: 0,
  init: false,
  jid: null,
};

const highstateReducer = (state = highstateInitialState, action) => {
  switch (action.type) {
    case "RESET_STORE":
    case "LOGOUT_STORE":
      return {
        ...highstateInitialState,
      };

    case INIT_HIGHSTATE:
      return {
        ...state,
        failures: 0,
        fetching: true,
        message: "Requesting software installation",
        status: "WAITING",
      };
    case INIT_HIGHSTATE_RETURN:
      return {
        ...state,
        ...action.payload,
        init: true,
        fetching: false,
      };
    case CHECKING_HIGHSTATE:
      return {
        ...state,
        fetching: true,
      };
    case HIGHSTATE_UPDATE:
      return {
        ...state,
        ...action.payload,
        fetching: false,
      };
    case HIGHSTATE_REQUEST_FAILED:
      if (state.failures > 3) {
        return {
          ...state,
          status: "FAILED",
          fetching: false,
        };
      } else {
        return {
          ...state,
          failures: state.failures++,
          fetching: false,
        };
      }

    default:
      return state;
  }
};

export default highstateReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/highstate.js